
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InitSubsidiaryAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subsidiaryAppTenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initSubsidiaryAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_subsidiaryAppTenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subsidiaryAppTenantId"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initSubsidiaryAdminResult"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appUserAuth0Info"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissionKey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inactive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"appTenantName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"appTenantId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parentAppTenantId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subsidiaries"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"appUserId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"preferredTimezone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contactId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recoveryEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"appRole"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"homePath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"libraries"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allowModalityConfiguration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundMode"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"licensingScope"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"subsidiaryAppTenant"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"identifier"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":820}};
    doc.loc.source = {"body":"mutation InitSubsidiaryAdmin(\n  $subsidiaryAppTenantId: String!\n) {\n  initSubsidiaryAdmin(input: {\n    _subsidiaryAppTenantId: $subsidiaryAppTenantId\n  }) {\n    initSubsidiaryAdminResult {\n\t    appUserAuth0Info {\n        permissionKey\n        username\n        inactive\n        appTenantName\n        appTenantId\n        parentAppTenantId\n        subsidiaries {\n          id\n          name\n        }\n        appUserId\n        preferredTimezone\n        contactId\n        firstName\n        lastName\n        recoveryEmail\n        appRole\n        permissions\n        homePath          \n        libraries {\n          id\n          name\n          allowModalityConfiguration\n          backgroundMode\n        }\n        licensingScope\n      }\n      subsidiaryAppTenant {\n        id\n        name\n        identifier\n      }\n   }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["InitSubsidiaryAdmin"] = oneQuery(doc, "InitSubsidiaryAdmin");
        
